import { Button } from "@material-ui/core";
import { styled, makeStyles } from "@material-ui/core/styles";
import { brand } from "./theme";

/** @deprecated Use a contained primary Button; retired during screen passes. */
export const ButtonGreen = styled(Button)({
  backgroundColor: brand.green,
  color: "white",
  "&:hover": {
    backgroundColor: brand.greenDark,
  },
});

export const CompanyCodeDisplay = styled("div")({
  fontSize: "14px",
  fontStyle: "italic",
  color: brand.textMedium,
  lineHeight: "3.75rem",
  textAlign: "right",
});

export const LoadingBackground = styled("div")({
  minHeight: "600px",
});

export const Overrides = makeStyles((theme) => ({
  textRight: {
    textAlign: "right",
    [theme.breakpoints.down("xs")]: {
      textAlign: "left",
    },
  },
  italic: {
    fontStyle: "italic",
  },
  failedIcon: {
    color: brand.plum,
    fontSize: "2em",
  },
  failedBorder: {
    borderColor: brand.plum,
  },
  successBorder: {
    border: `1px solid ${brand.green}`,
  },
  successIcon: {
    color: brand.green,
    fontSize: "2em",
  },
}));

export const ResponsiveClasses = makeStyles((theme) => ({
  breakOnSmall: {
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));
